// extracted by mini-css-extract-plugin
export default {"mainContainer":"Faq_mainContainer__NPiCX","faqItem":"Faq_faqItem__0HU1e","titleContainer":"Faq_titleContainer__+q0n7","faqDesc":"Faq_faqDesc__-kIpx"};